/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { authenticatedRequest } from '../common/authenticatedRequest';
import { documentsClient } from './documentsClient';
import { callsClient } from './callsClient';
import { sessionsClient } from './sessionsClient';
import { roomsClient } from './roomsClient';
import { tasksClient } from './tasksClient';
import { authClient } from './authClient';
import { goTo } from '@utils/routing';

// there is no login url for users so we kick them to / if they are not logged in
const request = authenticatedRequest(() => goTo('/'));

export const participantAPI = {
  auth: authClient(request),
  calls: callsClient(request),
  documents: documentsClient(request),
  rooms: roomsClient(request),
  sessions: sessionsClient(request),
  tasks: tasksClient(request),
};
